var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.type === 'problemOccurs')?_c('span',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$i18nPresenter.t('messageIfProblemStillOccurs'))}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }